export default "__VITE_ASSET__DkeCedxO__"